"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var RawTableAction = /** @class */ (function (_super) {
    __extends(RawTableAction, _super);
    function RawTableAction(props) {
        return _super.call(this, props) || this;
    }
    RawTableAction.prototype.buttonClick = function () {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    RawTableAction.prototype.getIconName = function () {
        var _ret = "warning";
        if (this.props.kind == "bonuses") {
            _ret = "shopping";
        }
        if (this.props.kind == "config") {
            _ret = "setting";
        }
        if (this.props.kind == "description") {
            _ret = "book";
        }
        return _ret;
    };
    RawTableAction.prototype.render = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
            React.createElement(antd_1.Button, { shape: "circle", size: "small", icon: this.getIconName(), ghost: true, type: "primary", style: { marginLeft: "1px", marginRight: "1px" }, onClick: this.buttonClick.bind(this), disabled: this.props.disabled })));
    };
    return RawTableAction;
}(React.Component));
exports.default = RawTableAction;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/table_actions/RawTableAction.tsx
// module id = 1978
// module chunks = 0